import { useState } from "react"
import Loading from "components/Loading"
import { Project } from "utils/types"
import { parseAspectRatio } from "utils/scriptJSON"
import useGeneratorPreview from "hooks/useGeneratorPreview"
import useWindowSize from "hooks/useWindowSize"

interface Props {
  project: Project
}

const ProjectExplore = ({ project }: Props) => {
  const windowSize = useWindowSize()
  const [dialogOpen, setDialogOpen] = useState(false)
  const { content, loading, error, refreshPreview } = useGeneratorPreview(project)

  const aspectRatio = project?.aspectRatio || parseAspectRatio(project?.scriptJSON) || 1
  const previewSize = Math.min(280, Math.max(180, windowSize.width - 96))
  const previewHeight = previewSize / aspectRatio

  return (
    <div className="mb-6">
      <button
        className="gallery-btn text-sm"
        onClick={() => setDialogOpen(true)}
      >
        Explore possibilities
      </button>

      {dialogOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center md:items-start justify-center bg-black/40 md:pt-32 px-4"
          onClick={() => setDialogOpen(false)}
        >
          <div
            className="bg-gallery-bg w-full max-w-sm p-6 sm:p-8 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-4 right-4 text-gallery-muted hover:text-gallery-text transition-colors"
              onClick={() => setDialogOpen(false)}
              aria-label="Close"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h3 className="font-serif text-xl mb-6">Exploring {project.name}</h3>

            <div
              className="flex items-center justify-center bg-gallery-border mb-4"
              style={{ width: previewSize, height: previewHeight, margin: "0 auto" }}
            >
              {loading ? (
                <Loading inline />
              ) : error ? (
                <p className="text-xs text-red-500">Error loading preview</p>
              ) : content ? (
                <iframe
                  title={`${project.name} preview`}
                  srcDoc={content}
                  width={previewSize}
                  height={previewHeight}
                  style={{ border: "none", display: "block" }}
                />
              ) : null}
            </div>

            <p className="text-xs text-gallery-muted text-center mb-4">
              Refresh to explore more possibilities
            </p>

            <div className="flex justify-center">
              <button className="gallery-btn-primary text-sm" onClick={refreshPreview}>
                Refresh
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProjectExplore
